import { Checkbox } from "@mui/material";
import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import FAW from "../../../../../containers/faw";
import { selectOrDeselectLesson } from "../../CreateAssignmentFlowUtilities";
import config from "../../../../../common/config";
import { lessonViewerWindowRef as lessonViewerWindowRefA } from "../../../../../redux/actions";
import {
  openRequestedTab,
  previewLessonUrl,
} from "../../../../../services/http";

const mapStateToProps = (state, ownProps?) => ({
  lessonViewerWindowRef: state.gui.lessonViewerWindowRef,
});

const PreviewLessonBtn = ({
  lessonId,
  lessonViewerWindowRef,
  dispatch,
  style,
}) => {
  return (
    <p style={{ textAlign: "center" }}>
      <span style={{ position: "relative" }}>
        <button
          className=' btn btn-sm btn-primary'
          style={style}
          onClick={(e) => {
            e.stopPropagation();
            const tabRef = openRequestedTab({
              url: previewLessonUrl(lessonId),
              windowRef: lessonViewerWindowRef,
              windowName: config.LESSONVIEWER_WINDOW_NAME,
            });
            dispatch(lessonViewerWindowRefA(tabRef));
          }}
          lesson-preview-data-title={"Preview lesson"}
        >
          <FAW icon='external-link-alt' />
        </button>
      </span>
    </p>
  );
};

const SelectLessonCheckbox = ({
  lessonType,
  isLessonSelected,
  handleOnChange,
  style,
}) => {
  return (
    <Checkbox
      onChange={(e) => {
        e.stopPropagation();
        handleOnChange(e, lessonType);
      }}
      style={style}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          handleOnChange(e, lessonType);
        }
      }}
      checked={isLessonSelected}
      size='small'
    />
  );
};

const StepOneLessonRow = ({
  lesson,
  lessons,
  setLessons,
  index,
  numInDisplayTable,
  selectedLessons,
  setSelectedLessons,
  numberOfLessonsSelected,
  setErrorMsg,
  isPopup = false,
  setPopupInfo,
  setShowPopupInfo,
  dispatch,
  lessonViewerWindowRef,
}) => {
  const handleSelectLesson = (e, lessonType) => {
    if (reachedMaxSelected(index, lessonType.toLowerCase())) {
      setMaxLessonsErrMsg();
      return;
    }
    selectOrDeselectLesson(
      lessons,
      setLessons,
      selectedLessons,
      setSelectedLessons,
      lessonType,
      lesson
    );
  };

  // only runs if the user attempts to add 11 or more lessons.
  const setMaxLessonsErrMsg = () => {
    setErrorMsg("No more than 10 lessons can be selected.");
  };

  /**
   * Determines if the user is attempting to select 11 or more lessons, which
   * is not allowed.
   * @param {int} index
   * @param {string} type
   * @returns boolean
   */
  const reachedMaxSelected = (index, type) => {
    if (index === -1) return false;
    if (lessons[index][type]) {
      return !lessons[index][type].selected && numberOfLessonsSelected >= 10;
    }
    // if it gets here, it was a deselection from the popup.
    return false;
  };

  const handleStandardClick = (e) => {
    e.stopPropagation();
    setPopupInfo({
      header: `Standard: ${lesson.standard}`,
      text: `${lesson.standard_description}`,
    });
    setShowPopupInfo(true);
  };

  return (
    <div>
      <div
        className={`choose_lesson_table_option_row ${
          lesson.tutorial.selected ? "selected_tut" : ""
        }`}
        style={{
          display: isPopup && !lesson.tutorial.selected ? "none" : "grid",
        }}
        onClick={(e) => {
          handleSelectLesson(null, "Tutorial");
        }}
      >
        <p className='index'>{numInDisplayTable}</p>
        <p>
          {lesson.course_name.endsWith("0")
            ? `${lesson.course_name.slice(0, -1)}K`
            : lesson.course_name}
        </p>
        <p>{lesson.unit}</p>
        <p
          style={{
            display: "flex",
            justifyContent: "left",
            marginLeft: "33%",
          }}
        >
          {lesson.course_name.startsWith("LIFE SKILLS") ? (
            <span>{lesson.standard_description}</span>
          ) : (
            <span
              style={{
                display: "flex",
                justifyContent: "left",
                alignItems: "center",
                minWidth: "100%",
              }}
            >
              <span
                onClick={handleStandardClick}
                style={{
                  cursor: "pointer",
                  textDecoration: "none",
                  transition: "text-decoration 0.2s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.textDecoration = "underline";
                  e.target.style.textDecorationColor = "black";
                }}
                onMouseLeave={(e) => {
                  e.target.style.textDecoration = "none";
                }}
              >
                {lesson.standard}
              </span>
            </span>
          )}
        </p>

        <p
          style={{
            display: "flex",
            justifyContent: "left",
            textAlign: "center",
            marginLeft: "40%",
          }}
        >
          Tutorial
        </p>
        <p>{lesson.tutorial.lesson_name}</p>
        <PreviewLessonBtn
          lessonId={lesson.tutorial.lesson_id}
          lessonViewerWindowRef={lessonViewerWindowRef}
          dispatch={dispatch}
          style={{ marginRight: "3px" }}
        />

        <SelectLessonCheckbox
          lessonType='Tutorial'
          isLessonSelected={lesson.tutorial.selected}
          handleOnChange={handleSelectLesson}
          style={{ marginRight: "2.3px" }}
        />
      </div>

      {lesson.assessment.lesson_id && (
        <div
          className={`choose_lesson_table_option_row ${
            lesson.assessment.selected ? "selected_asm" : ""
          } asm_row`}
          style={{
            display: isPopup && !lesson.assessment.selected ? "none" : "grid",
          }}
          onClick={() => {
            handleSelectLesson(null, "Assessment");
          }}
        >
          <p className='index'>
            {isPopup && !lesson.tutorial.selected
              ? numInDisplayTable
              : numInDisplayTable + 1}
          </p>
          <p>
            {lesson.course_name.endsWith("0")
              ? `${lesson.course_name.slice(0, -1)}K`
              : lesson.course_name}
          </p>
          <p>{lesson.unit}</p>
          <p
            style={{
              display: "flex",
              justifyContent: "left",
              marginLeft: "33%",
            }}
          >
            {lesson.course_name.startsWith("LIFE SKILLS") ? (
              <span>{lesson.standard_description}</span>
            ) : (
              <span
                style={{
                  display: "flex",
                  justifyContent: "left",
                  alignItems: "center",
                  minWidth: "100%",
                }}
              >
                <span
                  onClick={handleStandardClick}
                  style={{
                    cursor: "pointer",
                    textDecoration: "none",
                    transition: "text-decoration 0.2s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.textDecoration = "underline";
                    e.target.style.textDecorationColor = "black";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.textDecoration = "none";
                  }}
                >
                  {lesson.standard}
                </span>
              </span>
            )}
          </p>

          <p
            style={{
              display: "flex",
              justifyContent: "left",
              textAlign: "center",
              marginLeft: "40%",
            }}
          >
            Assessment
          </p>

          <p>{lesson.assessment.lesson_name}</p>
          <PreviewLessonBtn
            lessonId={lesson.assessment.lesson_id}
            lessonViewerWindowRef={lessonViewerWindowRef}
            dispatch={dispatch}
          />

          <SelectLessonCheckbox
            lessonType='Assessment'
            isLessonSelected={lesson.assessment.selected}
            handleOnChange={handleSelectLesson}
          />
        </div>
      )}
    </div>
  );
};

export default compose(connect(mapStateToProps))(StepOneLessonRow);
